<template>
    <div v-if="photos && photos.length" class="flex flex-wrap gap-1">
        <a
            v-for="photo in photos"
            :key="photo.id"
            :href="photo.file_url || photo.file"
            target="_blank"
            rel="noopener"
            class="block w-12 h-12 bg-gray-100 border rounded overflow-hidden hover:ring ring-accent-primary"
            :title="photo.caption || photo.original_filename || ''"
        >
            <img
                v-if="isImage(photo)"
                :src="photo.file_url || photo.file"
                :alt="photo.caption || ''"
                class="w-full h-full object-cover"
                loading="lazy"
            />
            <div v-else class="w-full h-full flex items-center justify-center text-[10px] text-gray-500 p-1 text-center">
                {{ shortName(photo) }}
            </div>
        </a>
    </div>
    <div v-else class="text-[11px] text-gray-400 italic">none</div>
</template>

<script setup>
import { defineProps } from 'vue';
defineProps(['photos']);

function isImage(photo) {
    const ct = (photo.content_type || '').toLowerCase();
    return ct.startsWith('image/');
}
function shortName(photo) {
    return (photo.original_filename || 'file').slice(0, 8);
}
</script>
